import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // Defaults to localStorage for web
import rootReducer from "./reducer";

// Configure redux-persist
const persistConfig = {
  key: "root", // Key for localStorage
  storage, // Storage mechanism (localStorage)
  whitelist: [
    "user_data",
    "bearer_token",
    "current_store",
    "current_cart",
    "userpermission_data",
    "rolesandpermission_data",
    "layoutstyledata",
  ], // Only persist these keys
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

// Create Redux store with the persisted reducer
const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // Disable serializable state check for redux-persist
    }),
});

// Create the persistor
export const persistor = persistStore(store);

export default store;
